import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function ToolPlaygroundCrumb(props: Partial<BreadcrumbData>) {
  const { toolName } = useParams<{ toolName: string }>();

  return (
    <Breadcrumb name={props.condensed ? '' : toolName || 'Tool'} {...props} />
  );
}
